export interface AnalyzeImageRequest {
  userPrompt: string;
  imageBytes?: string;
  imageUrl?: string;
  maxResponseTokens?: number;
  temperature?: number;
}

export interface AnalyzeImageResponse {
  rawLlMOutput?: string;
  title?: string;
  description?: string;
  objects?: string[];
  colors?: string[];
  composition?: string;
  mood?: string;
  style?: string;
  tags?: string[];
  technicalDetails?: { [key: string]: string };
}

export interface GenerateCinematicSummaryRequest {
  imageAnalysis?: string;
  style?: string;
  targetAudience?: string;
  maxTokens?: number;
}

export interface CinematicSummaryResponse {
  cinematicSummary?: string;
  genre?: string;
  themes?: string[];
  narrativeElements?: string[];
}

// Local storage models
export interface ImageAnalysisSession {
  id: string;
  imageUrl?: string;
  imageData?: string;
  prompt: string;
  analysis?: AnalyzeImageResponse;
  cinematicSummary?: string;
  createdAt: Date;
}

export interface ImageAnalysisSessionStorage {
  sessions: ImageAnalysisSession[];
  lastUpdated: Date;
}

// Constants
export const ANALYSIS_PROMPTS = [
  'Describe this image in detail',
  'What objects can you identify in this image?',
  'Analyze the composition and artistic style',
  'What emotions does this image evoke?',
  'Describe the color palette and lighting',
  'What story does this image tell?',
  'Identify any text or symbols in the image',
  'Analyze this from a professional photography perspective',
  'What is the cultural or historical context?',
  'Describe the technical aspects of this image'
];

export const CINEMATIC_STYLES = [
  'Film Noir',
  'Epic Adventure',
  'Romantic Drama',
  'Science Fiction',
  'Horror/Thriller',
  'Documentary',
  'Art House',
  'Action/Adventure',
  'Comedy',
  'Fantasy'
];